/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRange } from './DateRange';
import {
    DateRangeFromJSON,
    DateRangeFromJSONTyped,
    DateRangeToJSON,
    DateRangeToJSONTyped,
} from './DateRange';
import type { RelatedEntity } from './RelatedEntity';
import {
    RelatedEntityFromJSON,
    RelatedEntityFromJSONTyped,
    RelatedEntityToJSON,
    RelatedEntityToJSONTyped,
} from './RelatedEntity';
import type { AdditionalIdentification } from './AdditionalIdentification';
import {
    AdditionalIdentificationFromJSON,
    AdditionalIdentificationFromJSONTyped,
    AdditionalIdentificationToJSON,
    AdditionalIdentificationToJSONTyped,
} from './AdditionalIdentification';

/**
 * 
 * @export
 * @interface HospitalSnfStay
 */
export interface HospitalSnfStay {
    /**
     * 
     */
    date_ranges?: Array<DateRange>;
    /**
     * 
     */
    related_entities?: Array<RelatedEntity>;
    /**
     * 
     */
    additional_identifications?: Array<AdditionalIdentification>;
}

/**
 * Check if a given object implements the HospitalSnfStay interface.
 */
export function instanceOfHospitalSnfStay(value: object): value is HospitalSnfStay {
    return true;
}

export function HospitalSnfStayFromJSON(json: any): HospitalSnfStay {
    return HospitalSnfStayFromJSONTyped(json, false);
}

export function HospitalSnfStayFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospitalSnfStay {
    if (json == null) {
        return json;
    }
    return {
        
        'date_ranges': json['date_ranges'] == null ? undefined : ((json['date_ranges'] as Array<any>).map(DateRangeFromJSON)),
        'related_entities': json['related_entities'] == null ? undefined : ((json['related_entities'] as Array<any>).map(RelatedEntityFromJSON)),
        'additional_identifications': json['additional_identifications'] == null ? undefined : ((json['additional_identifications'] as Array<any>).map(AdditionalIdentificationFromJSON)),
    };
}

export function HospitalSnfStayToJSON(json: any): HospitalSnfStay {
    return HospitalSnfStayToJSONTyped(json, false);
}

export function HospitalSnfStayToJSONTyped(value?: HospitalSnfStay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_ranges': value['date_ranges'] == null ? undefined : ((value['date_ranges'] as Array<any>).map(DateRangeToJSON)),
        'related_entities': value['related_entities'] == null ? undefined : ((value['related_entities'] as Array<any>).map(RelatedEntityToJSON)),
        'additional_identifications': value['additional_identifications'] == null ? undefined : ((value['additional_identifications'] as Array<any>).map(AdditionalIdentificationToJSON)),
    };
}

